import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Peremeshka } from '../components/Peremeshka';
import { Routes, Route } from 'react-router-dom';
import ProgressBar from '../components/ProgressBar';
const variants = ["SD", "D", "SLD", "N", "SLA", "A", "SA"];
const  values = [-3, -2, -1, 0, 1, 2, 3];
const questionsTest = [
  { id:0,
    title: "Можно ли про вас сказать, что вы восстанавливаетесь в обществе других?",
    variants,
    values
  },
   {
    id:1,
    title: "Вам легко начать разговор с незнакомцами?",
   variants,
    values
  },
   {
    id:2,
    title: "Вам нравится быть в центре внимания?",
    variants,
    values
  },
  {
    id:3,
   title: "Легко ли вам заводить новых друзей?",
    variants,
    values
   },
  {
    id:4,
    title: "Помогает ли вам  найти решение проблемы проговаривание её вслух?",
    variants,
    values
   },
   {
    id:5,
    title: "Можно ли про вас сказать, что вы сначала делаете, а потом думаете",
    variants,
    values
  },
  {
    id:6,
    title: "При необходимости связаться с кем-то, вы выберите позвонить?",
    variants,
    values
  },
  {
    id:7,
    title: "Длительная изоляция станет бременем для вас?",
    variants,
    values
  },
  {
    id:8,
    title: "Другим людям легко определить в каком вы настроении?",
    variants,
    values
  },
  {
    id:9,
    title: "Вы много и быстро говорите?",
    variants,
    values
  },
  {
    id:10,
    title: "Вам легче и эффективнее работать в команде нежели одному?",
    variants,
    values
  },  
  {
    id:11,
    title: "Нравится ли вам быть в новом месте с незнакомцами?",
    variants,
    values
  },
  {
    id:12,
    title: "Вы часто сами начинаете разговор?",
    variants,
    values
  },
  {
    id:13,
    title: "Вы уходите последним с мероприятия?",
    variants,
    values
  },
  {
    id:14,
    title: "Часто ли вы уходите в свои мысли не замечая происходящего вокруг?",
    variants,
    values
  },
  {
    id:15,
    title: "Доверяете ли вы новым теориям больше проверенных методов?",
    variants,
    values
  },
   {
    id:16,
    title: "Обращаете ли вы внимание на визуальные детали, которые по мнению других кажутся незначительными?",
    variants,
    values
  },
   {
    id:17,
    title: "Вы живете принципом, живи сегодня как в последний раз?",
    variants,
    values
  },
  {
    id:18,
   title: "Вы читаете инструкцию перед применением",
    variants,
    values
   },
  {
    id:19,
    title: "Вам близки поэзия и абстрактное мышление?",
   variants,
    values
  },
   {
    id:20,
    title: "Вы любите  практичность?",
    variants,
    values
  },
  {
    id:21,
    title: "Рутинная работа с цифрами и фактами вас утомляет?",
    variants,
    values
  },
  {
    id:22,
    title: "Вы любитель теорий?",
    variants,
    values
  },
  {
    id:23,
    title: "Легко ли вам улавливать сарказм в разговоре?",
    variants,
    values
  },
  {
    id:24,
    title: "Вам легче запомнить общую атмосферу события, нежели четкие детали?",
    variants,
    values
  },
  {
    id:25,
    title: "Доставляет ли вам удовольствие технический прогресс?",
    variants,
    values
  },  
  {
    id:26,
    title: "Важнее ли для вас «как есть сейчас», чем «как могло бы быть»?",
    variants,
    values
  },
  {
    id:27,
    title: "Еда для вас больше чем просто топливо необходимое для жизни?",
    variants,
    values
  },
  {
    id:28,
    title: "Важны ли для вас общепринятые традиции?",
    variants,
    values
  },
  {
    id:29,
    title: "Полагаетесь ли вы на первое впечатление при оценке человека?",
    variants,
    values
  },

  {
    id:30,
    title: "Вместо того, чтобы сказать неприятную правду вы выберете промолчать и сохранить хорошие отношения?",
    variants,
    values
  },
   {
    id:31,
    title: "Можно ли использовать интеллектуальные дебаты и обсуждения научных теорий в качестве снотворного?",
    variants,
    values
  },
   {
    id:32,
    title: "Легко ли фильму или книге довести вас до слез?",
    variants,
    values
   },
  {
    id:33,
   title: "Вы беспощадны в своей критике?",
    variants,
    values
  },
  {
    id:34,
    title: "Если встанет выбор между сердцем и разумом, вы предпочтете сердце?",
    variants,
    values
  },
   {
    id:35,
    title: "Считаете ли вы что четкие правила необходимы для всех людей без исключения?",
    variants,
    values
  },
  {
    id:36,
    title: "Готовы ли вы при конфликте сглаживать ситуацию, даже если вы правы?",
    variants,
    values
  },
  {
    id:37,
    title: "Мнение людей подвергает сомнениям ваше мнение о себе?",
    variants,
    values
  },
  {
    id:38,
    title: "Легко ли вы отделяете профессиональные и личностные качества?",
    variants,
    values
  },
  {
    id:39,
    title: "Вам легко считывать настроение людей?",
    variants,
    values
  },
  {
    id:40,
    title: "Легко ли вас заставить чувствовать вину?",
    variants,
    values
  },  
  {
    id:41,
    title: "Честность и вежливость - антонимы?",
    variants,
    values
  },
  {
    id:42,
    title: "Смогли бы вы перестать общаться с другом, который плохо на вас влияет и вредит вашему развитию?",
    variants,
    values
  },
  {
    id:43,
    title: "Вам проще взаимодействовать с техникой, чем с людьми?",
    variants,
    values
  },
  {
    id:44,
    title: "Когда вам нужно убедить кого-то вы выберите эмоциональные призывы?",
    variants,
    values
  },
  {
    id:45,
    title: "Вы чувствуете дискомфорт, если не знаете расписания на завтра?",
    variants,
    values
  },
   {
    id:46,
    title: "Как часто вы выбираете делать всё в последнюю ночь перед сдачей?",
    variants,
    values
  },
   {
    id:47,
    title: "Ваше пространство часто кажется другим людям хаотичным, хотя для вас это порядок?",
    variants,
    values
   },
  {
    id:48,
   title: "Любите ли вы плыть по течению и решать задачи по настроению?",
   variants,
    values
  },
  {
    id:49,
    title: "Вы часто опаздываете?",
    variants,
    values
  },
   {
    id:50,
    title: "Рутина для вас пытка?",
    variants,
    values
  },
  {
    id:51,
    title: "Любите ли вы делать несколько проектов одновременно?",
    variants,
    values
  },
  {
    id:52,
    title: "Если проект утратил актуальность будете ли вы его заканчивать?",
    variants,
    values
  },
  {
    id:53,
    title: "Любите ли вы спонтанные события и сюрпризы?",
    variants,
    values
  },
  {
    id:54,
    title: "Легко ли вам принимать резкую смену планов",
    variants,
    values
  },
  {
    id:55,
    title: "Если правила кажутся вам бессмыслеными, вы будете их соблюдать?",
    variants,
    values
  },  
  {
    id:56,
    title: "Ваш отдых четко распланирован?",
    variants,
    values
  },
  {
    id:57,
    title: "Легко ли вы откажетесь от важных дел ради чего то интересного?",
    variants,
    values
  },
  {
    id:58,
    title: "Вам легче работать когда есть четкий план работы?",
    variants,
    values
  },
  {
    id:59,
    title: "В новом приложении вы предпочтете разобраться с функционалом самостоятельно?",
    variants,
    values
  }
]
function Test() {
  const [questions] = useState(() => Peremeshka(questionsTest));
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [selectId, setSelectId] = useState(null);
  
  const percentage = Math.round(step/60*100);

  const totalQuestions = questions.length;
  let question = questions[step];
  
  // const [variants, setVariants] = useState(() => 
  //  [...question.variants]
  //);
   const navigate = useNavigate();
  const handleClick = () => {
    const result = calculateMBTI(answers); 
    navigate('/result', { 
      state: result 
    });
  };
    
  const onClickVariant = (index) => 
    {
      setSelectId(index);
      setAnswers(prev => [...prev, { id: question.id, values: question.values[index] }]);
     setTimeout(() => {
      setStep(step+1);
      setSelectId(null);
      setShowResult(false);
    }, 300);
  }
  const handleVariantSelect = (questionId, value) => {
  setAnswers(prev => ({
    ...prev,
    [questionId]: value
  }));
  

  const question = questions.find(q => q.id === questionId);
  const index = question.values.indexOf(value);
  setSelectId(index);
  
  setTimeout(() => {
    setStep(prev => prev + 1);
    setSelectId(null);
  }, 300);
}
  const restart = () =>
  {
  setStep(0);
  setShowResult(false);
  setSelectId(null);
  }
  const calculateMBTI = (answers) =>
  {
    let IE;
    let NS;
    let TF;
    let PJ;
 //////////////IE
    let sumIE = 0;
    let countIE = 0;
   for(let i = 0; i <= 14; i++)
   {
    const value = answers[i];
    sumIE += value;
    countIE++;
   }
   if(sumIE < 0)
      IE = 'I';
    else
      IE = 'E';
////////////NS
    let sumNS = 0;
    let countNS = 0;
   for(let i = 15; i <= 29; i++)
   {
    const value = answers[i];
    sumNS += value;
    countNS++;
   }
   if(sumNS < 0)
      NS = 'S';
    else
      NS = 'N';
    ////////////TF
    let sumTF = 0;
    let countTF = 0;
   for(let i = 30; i <= 44; i++)
   {
    const value = answers[i];
    sumTF += value;
    countTF++;
   }
   if(sumTF < 0)
      TF = 'T';
    else
      TF = 'F';
    
    ////////////PJ
    let sumPJ = 0;
    let countPJ = 0;
   for(let i = 45; i <= 59; i++)
   {
    const value = answers[i];
    sumPJ += value;
    countPJ++;
   }
   if(sumPJ > 0)
      PJ = 'P';
    else
      PJ = 'J';
    
   return {sumIE, countIE, IE, sumNS, countNS, NS, sumTF, countTF, TF, sumPJ, countPJ, PJ};
  }
return (
 <div className="Glavn">
  <div className='catalog' >
     <ProgressBar percentage={percentage} />
    {questions.map((question, idx) => (
      <div key={idx} style={{fontSize:"40px"}}>
        <p>{question.title}</p>
        <div>
          {question.variants.map((variant, vIdx) => {
const colors = ['#0a0a0f',  '#1a1a2e',  '#2d2d4a', '#4a4a6a',  '#4a6a8a',  '#3a7aaa',  '#2a8acc' ];
            const size = [34, 28, 22, 16, 22, 28, 34];
           
            
            const isSelected = answers[question.id] === question.values[vIdx];

            return (
              <label key={vIdx} style={{ display: 'inline-flex',flexDirection: 'column', marginRight:"15px", alignItems: 'center', marginBottom: '5px', cursor: 'pointer', opacity: isSelected ? 1 : 0.6, minWidth: '60px', 
              transition: 'all 0.3s ease' }}>
                <input
                  type="radio"
                  name={`q${idx}`}
                 value={question.values[vIdx]}
              checked={isSelected}
              onChange={() => handleVariantSelect(question.id, question.values[vIdx])}
               style={{
                    width: `${size[vIdx]}px`,
                    height: `${size[vIdx]}px`,
                     border: `2px solid ${isSelected ? '#000' : colors[vIdx]}`, 
                   // border: `2px solid ${colors[vIdx]}`,
                    borderRadius: '50%',
                    marginBottom: '5px',
                    cursor: 'pointer',
                    backgroundColor: isSelected ? colors[vIdx] : 'white', 
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none'
                  }}
                />
                <span style={{ color: colors[vIdx], fontSize: '15px', }}>{variant}</span>
              </label>
            );
          })}
        </div>
      </div>
      
    ))}
    {Object.keys(answers).length == 60 ? (
      <div className="catalog-footer">
  <button className="catalog-btn" onClick={handleClick}>Перейти к типу личности</button>
  </div>
) : (
   <div className="catalog-footer">
  <button className="catalog-btn" disabled>Перейти к типу личности</button>
  </div>
)}
    </div>
   </div>
  );
}

export default Test;